// First-touch ad attribution. Ads launched from /admin/ads link here with
// utm_source/utm_campaign/utm_content(=Meta ad id) and Meta appends fbclid. We keep the
// first one we see for 30 days and every signup request sends it along
// (see auth/core/_requests.ts) — the API stores it on Account.ad_attribution.
const KEY = 'fbz_ad_attr'
const TTL_MS = 30 * 24 * 60 * 60 * 1000
const PARAMS = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_content', 'utm_term', 'fbclid']

type Attribution = Record<string, string | number>

function read(): Attribution | null {
  try {
    const raw = localStorage.getItem(KEY)
    if (!raw) return null
    const v = JSON.parse(raw)
    if (!v || Date.now() - Number(v.first_seen_at) > TTL_MS) return null
    return v
  } catch {
    return null
  }
}

function cookie(name: string): string | undefined {
  const m = document.cookie.match(new RegExp('(?:^|; )' + name + '=([^;]*)'))
  return m ? decodeURIComponent(m[1]) : undefined
}

// Call once at boot. Only a URL that carries ad params starts (or replaces an expired) record.
export function captureAdAttribution() {
  try {
    const q = new URLSearchParams(window.location.search)
    if (!PARAMS.some((p) => q.get(p))) return
    if (read()) return
    const v: Attribution = {first_seen_at: Date.now(), landing_url: window.location.href.slice(0, 500)}
    PARAMS.forEach((p) => {
      const x = q.get(p)
      if (x) v[p] = x
    })
    if (!v.utm_source && v.fbclid) v.utm_source = 'facebook'
    if (document.referrer) v.referrer = document.referrer.slice(0, 500)
    localStorage.setItem(KEY, JSON.stringify(v))
  } catch {
    // storage blocked — attribution is best-effort
  }
}

// What signup requests send. Includes the Meta pixel cookies when fbzipper.com set them
// on the shared .fbzipper.com domain.
export function getAdAttribution(): Attribution | undefined {
  const v: Attribution = {...(read() || {})}
  const fbp = cookie('_fbp')
  const fbc = cookie('_fbc')
  if (fbp) v.fbp = fbp
  if (fbc) v.fbc = fbc
  return Object.keys(v).length ? v : undefined
}
